import type { ReactNode, HTMLAttributes } from 'react'
import { classNames } from '~/utils/client/helpers'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'info'
  children?: ReactNode
  mobileFull?: boolean
  narrow?: boolean
}

export function Card({
  children,
  className,
  variant = 'default',
  narrow = false,
  ...rest
}: CardProps) {
  const variantStyle = variant === 'info' ? 'py-4 md:px-8 md:py-6 bg-surface-inset' : 'bg-white'
  return (
    <div
      className={classNames(
        'max-w-full w-full rounded-md',
        narrow ? '' : 'px-4 py-8 md:px-8 md:pt-10 md:pb-10 ',
        variantStyle,
        className
      )}
      {...rest}
    >
      {children}
    </div>
  )
}

export default Card
